import images from "./images";


const portfolio = [ 
    {
        id: 1,
        image: images.portfolio1,
        title: 'Leader Summit',
        details: {
            eventType: 'Business Events',
            date: 'Tue, 20 Aug 2024',
            time: '10:00 AM - 4:00 PM',
            venue: 'Downtown Conference Center',
            attendees: '300+ Participants',
            speakers: 'David Johnson, Dr. Emily Wang, Sarah Thompson',
            organizer: 'Corporate Leaders Network',
            number: '+123-456-7890',
            email: 'info@leadershipsummit.com',
            entryFee: '$150 per attendee'
        },
        paragraphs: [
            'Gain valuable insights into cutting-edge leadership strategies and forward-thinking management practices that define modern corporate success.',
            'Engage with renowned business leaders and industry experts as they share their perspectives on leadership evolution, organizational adaptability, and fostering a culture of innovation. Attendees will leave with actionable strategies to drive impactful change within their companies.'
        ],
        gallery: [
            images.portfolio1Gallery1,
            images.portfolio1Gallery2,
            images.portfolio1Gallery3,
            images.portfolio1Gallery4,
            images.portfolio1Gallery5,
            images.portfolio1Gallery6,
        ],
        highlights: [
            'Expert discussions on leadership transformation in dynamic markets.',
            'Hands-on workshops designed to refine executive decision-making skills.',
            'Premium networking opportunities with top industry professionals.',
            'Exclusive keynote sessions on emerging leadership trends.',
            'Panel discussions addressing the challenges of modern corporate leadership.'
        ],
        agenda: [
            'Welcome and Opening Remarks',
            'Keynote Address: "The Future of Leadership"',
            'Breakout Session: Adaptive Leadership Strategies',
            'Panel Discussion: Corporate Innovation & Change Management',
            'Networking Luncheon & Executive Meet-up'
        ],
        testimonials: [
            { quote: 'A must-attend event for anyone serious about leadership excellence!', author: 'Linda K.' },
            { quote: 'The discussions were thought-provoking and highly relevant to today’s corporate challenges.', author: 'Mark D.' },
            { quote: 'An outstanding platform for learning and networking with top-tier professionals.', author: 'Sarah P.' }
        ],
    },
    {
        id: 2,
        image: images.portfolio2,
        title: 'Brand Workshop',
        details: {
            eventType: 'Skill Sessions',
            date: 'Fri, 25 Oct 2024',
            time: '9:00 AM - 3:00 PM',
            venue: 'Grand Hall, Business Hub',
            attendees: '200+ Marketers & Entrepreneurs',
            speakers: 'Jessica Parker, Michael Smith, Dr. Anna Roberts',
            organizer: 'Marketing Innovators Association',
            number: '+987-654-3210',
            email: 'info@marketingworkshop.com',
            entryFee: '$100 per attendee'
        },
        paragraphs: [
            'Unlock the secrets of modern marketing and explore innovative strategies to enhance brand visibility, customer engagement, and business growth.',
            'Join industry experts as they share insights on digital marketing trends, content creation, social media tactics, and data-driven decision-making. This hands-on workshop is designed to equip participants with the latest tools and techniques for success in the competitive marketing landscape.'
        ],
        gallery: [
            images.portfolio2Gallery1,
            images.portfolio2Gallery2,
            images.portfolio2Gallery3,
            images.portfolio2Gallery4,
            images.portfolio2Gallery5,
            images.portfolio2Gallery6,
        ],
        highlights: [
            'In-depth sessions on digital marketing and branding strategies.',
            'Hands-on exercises to create compelling marketing campaigns.',
            'Networking opportunities with marketing professionals and business leaders.',
            'Exclusive insights into the latest trends in consumer behavior.',
            'Panel discussions on maximizing ROI in marketing efforts.'
        ],
        agenda: [
            'Welcome and Registration',
            'Keynote Speech: "The Future of Digital Marketing"',
            'Workshop: Building a Strong Brand Identity',
            'Panel Discussion: Data-Driven Marketing Strategies',
            'Networking Session & Closing Remarks'
        ],
        testimonials: [
            { quote: 'This workshop provided game-changing insights for my business!', author: 'Emily R.' },
            { quote: 'The speakers were incredibly knowledgeable and engaging.', author: 'James T.' },
            { quote: 'I walked away with actionable marketing strategies to implement immediately.', author: 'Sophia M.' }
        ],
    },
    {
        id: 3,
        image: images.portfolio3,
        title: 'Network Meet',
        details: {
            eventType: 'Business Events',
            date: 'Thu, 12 Sep 2024',
            time: '6:00 PM - 10:00 PM',
            venue: 'Skyline Rooftop, City Center',
            attendees: '150+ Professionals & Entrepreneurs',
            speakers: 'Robert Williams, Olivia Carter, Daniel Brown',
            organizer: 'Business Connect Hub',
            number: '+321-654-0987',
            email: 'info@networkingevent.com',
            entryFee: '$80 per attendee'
        },
        paragraphs: [
            'Expand your professional network and forge valuable connections at this exclusive networking event designed for business leaders, entrepreneurs, and industry professionals.',
            'Engage in meaningful conversations, exchange ideas, and discover collaboration opportunities in a relaxed and sophisticated setting. This event is perfect for those looking to build lasting business relationships and gain industry insights from experienced professionals.'
        ],
        gallery: [
            images.portfolio3Gallery1,
            images.portfolio3Gallery2,
            images.portfolio3Gallery3,
            images.portfolio3Gallery4,
            images.portfolio3Gallery5,
            images.portfolio3Gallery6,
        ],
        highlights: [
            'Exclusive meet-and-greet sessions with industry leaders.',
            'Interactive networking games to facilitate introductions.',
            'Panel discussions on effective networking strategies.',
            'Opportunities to connect with potential business partners and clients.',
            'Casual yet professional atmosphere for meaningful conversations.'
        ],
        agenda: [
            'Welcome Reception & Registration',
            'Opening Remarks by Event Organizer',
            'Speed Networking Session',
            'Panel Discussion: "Building Strong Business Relationships"',
            'Closing Remarks & Informal Networking'
        ],
        testimonials: [
            { quote: 'A fantastic opportunity to connect with like-minded professionals!', author: 'Amanda L.' },
            { quote: 'The structured networking sessions were incredibly valuable.', author: 'Brian K.' },
            { quote: 'I met several potential business partners in just one evening!', author: 'Jessica M.' }
        ],
    },
    {
        id: 4,
        image: images.portfolio4,
        title: 'Tech Showcase',
        details: {
            eventType: 'Product Displays',
            date: 'Mon, 18 Nov 2024',
            time: '9:00 AM - 6:00 PM',
            venue: 'Innovation Convention Center',
            attendees: '500+ Tech Enthusiasts & Professionals',
            speakers: 'Elena Martinez, Dr. Kevin Roberts, Jason Lee',
            organizer: 'Global Tech Innovations',
            number: '+456-789-1230',
            email: 'info@techexpo.com',
            entryFee: '$200 per attendee'
        },
        paragraphs: [
            'Discover the latest advancements in technology and innovation at Tech Expo, where industry leaders, startups, and tech enthusiasts come together to explore groundbreaking developments.',
            'Experience hands-on demonstrations, insightful panel discussions, and product showcases featuring cutting-edge solutions in AI, cybersecurity, robotics, and more. This trade show is a must-attend event for anyone passionate about the future of technology.'
        ],
        gallery: [
            images.portfolio4Gallery1,
            images.portfolio4Gallery2,
            images.portfolio4Gallery3,
            images.portfolio4Gallery4,
            images.portfolio4Gallery5,
            images.portfolio4Gallery6,
        ],
        highlights: [
            'Live demos of the latest tech innovations and products.',
            'Expert-led discussions on the future of AI, IoT, and cybersecurity.',
            'Exclusive networking opportunities with tech industry professionals.',
            'Startup showcase featuring emerging tech companies.',
            'Workshops on leveraging technology for business growth.'
        ],
        agenda: [
            'Opening Ceremony & Welcome Address',
            'Keynote Speech: "The Future of Emerging Technologies"',
            'Tech Panel: Innovations in Artificial Intelligence',
            'Product Demonstrations & Startup Pitch Session',
            'Closing Remarks & Networking Hour'
        ],
        testimonials: [
            { quote: 'An incredible experience showcasing the latest in technology!', author: 'David P.' },
            { quote: 'I gained valuable insights and made great industry connections.', author: 'Sophia R.' },
            { quote: 'A must-visit event for anyone in the tech industry!', author: 'Liam T.' }
        ],
    },
    {
        id: 5,
        image: images.portfolio5,
        title: 'Founder Bootcamp',
        details: {
            eventType: 'Skill Sessions',
            date: 'Sat, 15 Dec 2024',
            time: '10:00 AM - 5:00 PM',
            venue: 'Entrepreneur Hub, Downtown',
            attendees: '100+ Aspiring Entrepreneurs & Startups',
            speakers: 'Emma Reynolds, Chris Adams, Dr. Laura Bennett',
            organizer: 'Startup Success Academy',
            number: '+567-890-2341',
            email: 'info@startupbootcamp.com',
            entryFee: '$120 per attendee'
        },
        paragraphs: [
            'Turn your business idea into reality with expert guidance at the Startup Bootcamp. Learn the essential skills, strategies, and resources needed to launch and grow a successful startup.',
            'This intensive seminar covers business planning, funding strategies, marketing tactics, and scaling techniques. Connect with experienced mentors and fellow entrepreneurs to refine your business model and take the next step toward success.'
        ],
        gallery: [
            images.portfolio5Gallery1,
            images.portfolio5Gallery2,
            images.portfolio5Gallery3,
            images.portfolio5Gallery4,
            images.portfolio5Gallery5,
            images.portfolio5Gallery6,
        ],
        highlights: [
            'Practical sessions on business planning and funding options.',
            'Guidance from successful entrepreneurs and industry experts.',
            'Interactive workshops on branding and customer acquisition.',
            'Networking opportunities with investors and startup founders.',
            'Panel discussions on overcoming challenges in the startup journey.'
        ],
        agenda: [
            'Welcome & Introduction to Startup Bootcamp',
            'Keynote: "Building a Scalable Startup"',
            'Workshop: Crafting a Winning Business Plan',
            'Panel Discussion: Funding Your Startup – Investors & Strategies',
            'Closing Remarks & Networking Session'
        ],
        testimonials: [
            { quote: 'This bootcamp provided the foundation I needed to launch my startup!', author: 'Olivia N.' },
            { quote: 'The mentorship and networking opportunities were invaluable.', author: 'Ethan W.' },
            { quote: 'A must-attend for any aspiring entrepreneur!', author: 'Sophia J.' }
        ],
    },
    {
        id: 6,
        image: images.portfolio6,
        title: 'Gadget Expo',
        details: {
            eventType: 'Product Displays',
            date: 'Fri, 22 Nov 2024',
            time: '10:00 AM - 7:00 PM',
            venue: 'Grand Tech Expo Center',
            attendees: '800+ Industry Professionals & Tech Enthusiasts',
            speakers: 'Michael Carter, Sophia Lee, Dr. Richard Adams',
            organizer: 'Global Electronics Forum',
            number: '+678-901-3452',
            email: 'info@electronicsshow.com',
            entryFee: '$250 per attendee'
        },
        paragraphs: [
            'Experience the future of electronics at the premier Electronics Show, where industry leaders, innovators, and top brands showcase the latest advancements in consumer and industrial electronics.',
            'From cutting-edge gadgets and smart home devices to breakthrough AI-powered technology, this trade show is a must-attend event for tech enthusiasts, manufacturers, and business leaders looking to stay ahead of the curve.'
        ],
        gallery: [
            images.portfolio6Gallery1,
            images.portfolio6Gallery2,
            images.portfolio6Gallery3,
            images.portfolio6Gallery4,
            images.portfolio6Gallery5,
            images.portfolio6Gallery6,
        ],
        highlights: [
            'Live demonstrations of the latest consumer electronics.',
            'Expert panels on the future of AI and smart technology.',
            'Networking opportunities with industry professionals and manufacturers.',
            'Product showcases featuring top brands and emerging startups.',
            'Workshops on sustainable and energy-efficient electronics solutions.'
        ],
        agenda: [
            'Opening Ceremony & Welcome Speech',
            'Keynote: "The Evolution of Consumer Electronics"',
            'Panel Discussion: Innovations in AI & Smart Devices',
            'Product Launches & Live Demonstrations',
            'Networking & Closing Remarks'
        ],
        testimonials: [
            { quote: 'A fantastic event for anyone passionate about the latest in electronics!', author: 'Daniel M.' },
            { quote: 'The live demos and product showcases were incredible!', author: 'Sophia R.' },
            { quote: 'Great networking opportunities with industry leaders!', author: 'Lucas T.' }
        ],
    },

];

export default portfolio;